import { Injectable } from '@angular/core';
import { ICategory } from '../interfaces';
import { ApiService } from '../../../../core/services';
import { Observable } from 'rxjs';
import { GenericService } from '../../../../core/services/GenericService';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SeminarsCategoriesService extends GenericService<ICategory> {

  protected readonly baseUrl = '/seminars/categories';

  public constructor(
    public readonly apiService: ApiService
  ) {
    super(apiService);
  }

  public getByName(name: string): Observable<ICategory> {
    return this.getQueryableAll(0, 1, null, null, [{ key: 'name', value: [name] }], [], []).pipe(
      map(res => res.results[0])
    );
  }

  public override getById(id: string): Observable<ICategory> {
    return this.getQueryableAll(0, 1, null, null, [{ key: 'id', value: [id] }], [], []).pipe(
      map(res => res.results[0])
    );
  }
}
